import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2AdminEncountersStartProcessing: build.mutation<
      PostV2AdminEncountersStartProcessingApiResponse,
      PostV2AdminEncountersStartProcessingApiArg
    >({
      query: () => ({
        url: `/v2/admin/encounters/start-processing`,
        method: "POST",
      }),
    }),
    getV2AdminEncountersTelemetryAnalytics: build.query<
      GetV2AdminEncountersTelemetryAnalyticsApiResponse,
      GetV2AdminEncountersTelemetryAnalyticsApiArg
    >({
      query: () => ({ url: `/v2/admin/encounters/telemetry/analytics` }),
    }),
    getV2AdminEncountersTelemetrySessions: build.query<
      GetV2AdminEncountersTelemetrySessionsApiResponse,
      GetV2AdminEncountersTelemetrySessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/encounters/telemetry/sessions`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2AdminEncountersByEncounterId: build.query<
      GetV2AdminEncountersByEncounterIdApiResponse,
      GetV2AdminEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/encounters/${queryArg.encounterId}`,
      }),
    }),
    getV2AdminProvidersByProviderIdEncounters: build.query<
      GetV2AdminProvidersByProviderIdEncountersApiResponse,
      GetV2AdminProvidersByProviderIdEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/encounters`,
      }),
    }),
    getV2ProviderBillingEncounters: build.query<
      GetV2ProviderBillingEncountersApiResponse,
      GetV2ProviderBillingEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          billable: queryArg.billable,
          has_claim: queryArg.hasClaim,
          ready_to_bill: queryArg.readyToBill,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingEncountersUnifiedWorklist: build.query<
      GetV2ProviderBillingEncountersUnifiedWorklistApiResponse,
      GetV2ProviderBillingEncountersUnifiedWorklistApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/unified-worklist`,
        params: {
          work_state: queryArg.workState,
          stage: queryArg.stage,
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          owner: queryArg.owner,
          severity: queryArg.severity,
          has_claim: queryArg.hasClaim,
          stale_only: queryArg.staleOnly,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingEncountersByEncounterId: build.query<
      GetV2ProviderBillingEncountersByEncounterIdApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdClaimWorkspace: build.query<
      GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/claim-workspace`,
        params: {
          claim_id: queryArg.claimId,
        },
      }),
    }),
    postV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefresh:
      build.mutation<
        PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiResponse,
        PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing/encounters/${queryArg.encounterId}/claim-workspace/refresh`,
          method: "POST",
          body: queryArg.unifiedEncounterClaimWorkspaceRefreshRequest,
        }),
      }),
    getV2ProviderBillingEncountersByEncounterIdFlow: build.query<
      GetV2ProviderBillingEncountersByEncounterIdFlowApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdFlowApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/flow`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdOverview: build.query<
      GetV2ProviderBillingEncountersByEncounterIdOverviewApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/overview`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdPayments: build.query<
      GetV2ProviderBillingEncountersByEncounterIdPaymentsApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdPaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/payments`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdReadiness: build.query<
      GetV2ProviderBillingEncountersByEncounterIdReadinessApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/readiness`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdUnified: build.query<
      GetV2ProviderBillingEncountersByEncounterIdUnifiedApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdUnifiedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/unified`,
      }),
    }),
    getV2ProviderEncounters: build.query<
      GetV2ProviderEncountersApiResponse,
      GetV2ProviderEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters`,
        params: {
          patient_id: queryArg.patientId,
          appointment_id: queryArg.appointmentId,
          organization_id: queryArg.organizationId,
          status: queryArg.status,
          encounter_type: queryArg.encounterType,
          template_id: queryArg.templateId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2ProviderEncounters: build.mutation<
      PostV2ProviderEncountersApiResponse,
      PostV2ProviderEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters`,
        method: "POST",
        body: queryArg.createEncounterRequest,
      }),
    }),
    postV2ProviderEncountersCreateTranscriptOnEncounterFromExample:
      build.mutation<
        PostV2ProviderEncountersCreateTranscriptOnEncounterFromExampleApiResponse,
        PostV2ProviderEncountersCreateTranscriptOnEncounterFromExampleApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/encounters/createTranscriptOnEncounterFromExample`,
          method: "POST",
          body: queryArg.createTranscriptOnEncounterFromExampleRequest,
        }),
      }),
    getV2ProviderEncountersDefaults: build.query<
      GetV2ProviderEncountersDefaultsApiResponse,
      GetV2ProviderEncountersDefaultsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/defaults`,
        params: {
          organization_id: queryArg.organizationId,
          encounter_type_id: queryArg.encounterTypeId,
          patient_id: queryArg.patientId,
        },
      }),
    }),
    postV2ProviderEncountersFromAppointmentByAppointmentId: build.mutation<
      PostV2ProviderEncountersFromAppointmentByAppointmentIdApiResponse,
      PostV2ProviderEncountersFromAppointmentByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/from-appointment/${queryArg.appointmentId}`,
        method: "POST",
        params: {
          apply_defaults: queryArg.applyDefaults,
        },
      }),
    }),
    postV2ProviderEncountersTelemetry: build.mutation<
      PostV2ProviderEncountersTelemetryApiResponse,
      PostV2ProviderEncountersTelemetryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/telemetry`,
        method: "POST",
        body: queryArg.logTelemetryEventsRequest,
      }),
    }),
    getV2ProviderEncountersTelemetryByEncounterId: build.query<
      GetV2ProviderEncountersTelemetryByEncounterIdApiResponse,
      GetV2ProviderEncountersTelemetryByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/telemetry/${queryArg.encounterId}`,
      }),
    }),
    deleteV2ProviderEncountersByEncounterId: build.mutation<
      DeleteV2ProviderEncountersByEncounterIdApiResponse,
      DeleteV2ProviderEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderEncountersByEncounterId: build.query<
      GetV2ProviderEncountersByEncounterIdApiResponse,
      GetV2ProviderEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}`,
      }),
    }),
    patchV2ProviderEncountersByEncounterId: build.mutation<
      PatchV2ProviderEncountersByEncounterIdApiResponse,
      PatchV2ProviderEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}`,
        method: "PATCH",
        body: queryArg.encounterUpdate,
        params: {
          include_defaults: queryArg.includeDefaults,
        },
      }),
    }),
    getV2ProviderEncountersByEncounterIdActionsSuggested: build.query<
      GetV2ProviderEncountersByEncounterIdActionsSuggestedApiResponse,
      GetV2ProviderEncountersByEncounterIdActionsSuggestedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/actions/suggested`,
      }),
    }),
    postV2ProviderEncountersByEncounterIdDocuments: build.mutation<
      PostV2ProviderEncountersByEncounterIdDocumentsApiResponse,
      PostV2ProviderEncountersByEncounterIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/documents`,
        method: "POST",
        body: queryArg.createDocumentRequest,
      }),
    }),
    deleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentId:
      build.mutation<
        DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse,
        DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/encounters/${queryArg.encounterId}/documents/${queryArg.documentId}`,
          method: "DELETE",
        }),
      }),
    getV2ProviderEncountersByEncounterIdDocumentsAndDocumentId: build.query<
      GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse,
      GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/documents/${queryArg.documentId}`,
      }),
    }),
    patchV2ProviderEncountersByEncounterIdDocumentsAndDocumentId:
      build.mutation<
        PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse,
        PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/encounters/${queryArg.encounterId}/documents/${queryArg.documentId}`,
          method: "PATCH",
          body: queryArg.documentUpdate,
        }),
      }),
    getV2ProviderEncountersByEncounterIdProcessingStatus: build.query<
      GetV2ProviderEncountersByEncounterIdProcessingStatusApiResponse,
      GetV2ProviderEncountersByEncounterIdProcessingStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/processing-status`,
      }),
    }),
    deleteV2ProviderEncountersByEncounterIdTranscripts: build.mutation<
      DeleteV2ProviderEncountersByEncounterIdTranscriptsApiResponse,
      DeleteV2ProviderEncountersByEncounterIdTranscriptsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/transcripts`,
        method: "DELETE",
      }),
    }),
    putV2ProviderEncountersByEncounterIdWorkingBillingClaim: build.mutation<
      PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiResponse,
      PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/working-billing-claim`,
        method: "PUT",
        body: queryArg.workingBillingClaimPutRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2AdminEncountersStartProcessingApiResponse =
  /** status 200 OK */ StartProcessingResponse;
export type PostV2AdminEncountersStartProcessingApiArg = void;
export type GetV2AdminEncountersTelemetryAnalyticsApiResponse =
  /** status 200 OK */ AdminTelemetryAnalyticsResponse;
export type GetV2AdminEncountersTelemetryAnalyticsApiArg = void;
export type GetV2AdminEncountersTelemetrySessionsApiResponse =
  /** status 200 OK */ ListResponseAdminTelemetrySessionListItem;
export type GetV2AdminEncountersTelemetrySessionsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by user/provider ID */
  userId?: string | null;
  /** Filter sessions created on or after this date (inclusive) */
  dateFrom?: string | null;
  /** Filter sessions created on or before this date (inclusive) */
  dateTo?: string | null;
  /** Field to sort by: 'created_at' or 'updated_at' */
  sortBy?: string | null;
  /** Sort direction: 'asc' or 'desc' */
  sortOrder?: string | null;
};
export type GetV2AdminEncountersByEncounterIdApiResponse =
  /** status 200 OK */ AdminEncounterDetailResponse;
export type GetV2AdminEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2AdminProvidersByProviderIdEncountersApiResponse =
  /** status 200 OK */ ListResponseAdminEncounterResponse;
export type GetV2AdminProvidersByProviderIdEncountersApiArg = {
  providerId: string;
};
export type GetV2ProviderBillingEncountersApiResponse =
  /** status 200 OK */ OrgBillingEncounterListResponse;
export type GetV2ProviderBillingEncountersApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by encounter status (e.g. completed) */
  status?: string | null;
  /** Filter by billable status */
  billable?: boolean | null;
  /** Filter by whether encounter has an associated claim */
  hasClaim?: boolean | null;
  /** Comma-separated ready-to-bill statuses to filter by (green, yellow, red) */
  readyToBill?: string | null;
  /** Filter by primary payer UUID */
  payerUuid?: string | null;
  /** Filter encounters from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter encounters up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Field to sort by (scheduled_for, created_at) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingEncountersUnifiedWorklistApiResponse =
  /** status 200 OK */ UnifiedEncounterWorklistResponse;
export type GetV2ProviderBillingEncountersUnifiedWorklistApiArg = {
  /** Filter by list work state */
  workState?: ("all" | "action" | "waiting" | "clear") | null;
  /** Filter by active 5S stage */
  stage?:
    | ("all" | "schedule" | "support" | "sign" | "submit" | "settle")
    | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by primary payer UUID */
  payerUuid?: string | null;
  /** Filter service dates from ISO date */
  dateFrom?: string | null;
  /** Filter service dates through ISO date */
  dateTo?: string | null;
  /** Filter by work owner */
  owner?:
    | ("front_desk" | "clinician" | "biller" | "payer" | "patient" | "none")
    | null;
  /** Filter by severity */
  severity?: ("info" | "warning" | "error" | "success") | null;
  /** Filter by claim existence */
  hasClaim?: boolean | null;
  /** Only return stale action/waiting items */
  staleOnly?: boolean;
  /** Sort field */
  sortBy?: "dos" | "age" | "amount" | "activity";
  /** Sort direction */
  sortOrder?: "asc" | "desc";
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingEncountersByEncounterIdApiResponse =
  /** status 200 OK */ OrgBillingEncounterDetailResponse;
export type GetV2ProviderBillingEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiResponse =
  /** status 200 OK */ UnifiedEncounterClaimWorkspaceResponse;
export type GetV2ProviderBillingEncountersByEncounterIdClaimWorkspaceApiArg = {
  encounterId: string;
  /** Claim ID to select as the active workspace claim. */
  claimId?: string | null;
};
export type PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiResponse =
  /** status 200 OK */ UnifiedEncounterClaimWorkspaceResponse;
export type PostV2ProviderBillingEncountersByEncounterIdClaimWorkspaceRefreshApiArg =
  {
    encounterId: string;
    unifiedEncounterClaimWorkspaceRefreshRequest: UnifiedEncounterClaimWorkspaceRefreshRequest;
  };
export type GetV2ProviderBillingEncountersByEncounterIdFlowApiResponse =
  /** status 200 OK */ UnifiedEncounterBillingFlowResponse;
export type GetV2ProviderBillingEncountersByEncounterIdFlowApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdOverviewApiResponse =
  /** status 200 OK */ UnifiedEncounterOverviewResponse;
export type GetV2ProviderBillingEncountersByEncounterIdOverviewApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdPaymentsApiResponse =
  /** status 200 OK */ UnifiedEncounterPaymentsWorkspaceResponse;
export type GetV2ProviderBillingEncountersByEncounterIdPaymentsApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdReadinessApiResponse =
  /** status 200 OK */ EncounterReadinessResponse;
export type GetV2ProviderBillingEncountersByEncounterIdReadinessApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdUnifiedApiResponse =
  /** status 200 OK */ UnifiedEncounterBillingResponse;
export type GetV2ProviderBillingEncountersByEncounterIdUnifiedApiArg = {
  encounterId: string;
};
export type GetV2ProviderEncountersApiResponse =
  /** status 200 OK */ EncounterListResponse;
export type GetV2ProviderEncountersApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Filter by appointment ID */
  appointmentId?: string | null;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by encounter status */
  status?: ("pending" | "processing" | "completed") | null;
  /** Filter by encounter type */
  encounterType?: string | null;
  /** Filter by template ID */
  templateId?: string | null;
  /** Filter encounters from this date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter encounters up to this date (YYYY-MM-DD) */
  dateTo?: string | null;
  /** Field to sort by */
  sortBy?: "created_at" | "start_time" | "end_time" | "modified_at";
  /** Sort order */
  sortOrder?: "asc" | "desc";
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type PostV2ProviderEncountersApiResponse =
  /** status 201 Created */ EncounterResponse2;
export type PostV2ProviderEncountersApiArg = {
  createEncounterRequest: CreateEncounterRequest;
};
export type PostV2ProviderEncountersCreateTranscriptOnEncounterFromExampleApiResponse =
  unknown;
export type PostV2ProviderEncountersCreateTranscriptOnEncounterFromExampleApiArg =
  {
    createTranscriptOnEncounterFromExampleRequest: CreateTranscriptOnEncounterFromExampleRequest;
  };
export type GetV2ProviderEncountersDefaultsApiResponse =
  /** status 200 OK */ AttestationDefaultsApiResponse;
export type GetV2ProviderEncountersDefaultsApiArg = {
  /** Organization ID for organization-level defaults */
  organizationId?: string | null;
  /** Encounter type ID for encounter type defaults */
  encounterTypeId?: string | null;
  /** Patient ID for patient-specific defaults */
  patientId?: string | null;
};
export type PostV2ProviderEncountersFromAppointmentByAppointmentIdApiResponse =
  /** status 201 Created */ EncounterResponse2;
export type PostV2ProviderEncountersFromAppointmentByAppointmentIdApiArg = {
  appointmentId: string;
  /** If true, compute and apply attestation defaults (modality, place_of_service, icd10_codes, cpt_codes, attestations) based on context. Defaults to true for appointment-based encounters. */
  applyDefaults?: boolean | null;
};
export type PostV2ProviderEncountersTelemetryApiResponse =
  /** status 200 OK */ LogTelemetryEventsResponse;
export type PostV2ProviderEncountersTelemetryApiArg = {
  logTelemetryEventsRequest: LogTelemetryEventsRequest;
};
export type GetV2ProviderEncountersTelemetryByEncounterIdApiResponse =
  /** status 200 OK */ TelemetrySessionResponse;
export type GetV2ProviderEncountersTelemetryByEncounterIdApiArg = {
  encounterId: string;
};
export type DeleteV2ProviderEncountersByEncounterIdApiResponse = unknown;
export type DeleteV2ProviderEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2ProviderEncountersByEncounterIdApiResponse =
  /** status 200 OK */ EncounterResponse2;
export type GetV2ProviderEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type PatchV2ProviderEncountersByEncounterIdApiResponse =
  /** status 200 OK */ EncounterResponse2;
export type PatchV2ProviderEncountersByEncounterIdApiArg = {
  encounterId: string;
  /** If true, compute and return suggested defaults based on current encounter state. Use when patient_id or encounter_type changes. */
  includeDefaults?: boolean | null;
  encounterUpdate: EncounterUpdate;
};
export type GetV2ProviderEncountersByEncounterIdActionsSuggestedApiResponse =
  /** status 200 OK */ ActionListResponse;
export type GetV2ProviderEncountersByEncounterIdActionsSuggestedApiArg = {
  encounterId: string;
};
export type PostV2ProviderEncountersByEncounterIdDocumentsApiResponse =
  /** status 201 Created */ DocumentResponse;
export type PostV2ProviderEncountersByEncounterIdDocumentsApiArg = {
  encounterId: string;
  createDocumentRequest: CreateDocumentRequest;
};
export type DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse =
  unknown;
export type DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg =
  {
    encounterId: string;
    documentId: string;
  };
export type GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse =
  /** status 200 OK */ DocumentResponse;
export type GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg = {
  encounterId: string;
  documentId: string;
};
export type PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse =
  /** status 200 OK */ DocumentResponse;
export type PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg =
  {
    encounterId: string;
    documentId: string;
    documentUpdate: DocumentUpdate;
  };
export type GetV2ProviderEncountersByEncounterIdProcessingStatusApiResponse =
  /** status 200 OK */ EncounterProcessingStatusResponse;
export type GetV2ProviderEncountersByEncounterIdProcessingStatusApiArg = {
  encounterId: string;
};
export type DeleteV2ProviderEncountersByEncounterIdTranscriptsApiResponse =
  /** status 200 OK */ TranscriptDeletionResponse;
export type DeleteV2ProviderEncountersByEncounterIdTranscriptsApiArg = {
  encounterId: string;
};
export type PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiResponse =
  /** status 200 OK */ EncounterResponse2;
export type PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiArg = {
  encounterId: string;
  workingBillingClaimPutRequest: WorkingBillingClaimPutRequest2;
};
export type StartProcessingResponse = {
  encounter_id?: string | null;
  message: string;
  note_id?: string | null;
  status: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type DistributionStats = {
  /** Number of data points */
  count: number;
  /** Maximum value */
  max: number;
  /** Mean (average) value */
  mean: number;
  /** Median (p50) value */
  median: number;
  /** Minimum value */
  min: number;
  /** 50th percentile */
  p50: number;
  /** 75th percentile */
  p75: number;
  /** 90th percentile */
  p90: number;
  /** 95th percentile */
  p95: number;
  /** 99th percentile */
  p99: number;
};
export type CopyAnalytics = {
  /** Copies per selection (copy_count / select_count) */
  copy_rate?: number;
  /** Copy count by modality (keyboard, mouse, copy_button, etc.) */
  modality_breakdown?: {
    [key: string]: number;
  };
  /** Top sections by copy count (section_id, section_title, copy_count) */
  most_copied_sections?: {
    [key: string]: any;
  }[];
  /** Statistics for selection as percent of total */
  selection_percent_stats?: DistributionStats | null;
  /** Statistics for selection sizes (in characters) */
  selection_size_stats?: DistributionStats | null;
  /** Statistics for time from settle to copy */
  time_to_copy_stats?: DistributionStats | null;
  /** Total copy events */
  total_copies?: number;
};
export type DocumentAnalytics = {
  /** Total character delta across all edits */
  char_delta_total?: number;
  /** Total clicks in document */
  click_count?: number;
  /** Total copies from document */
  copy_count?: number;
  /** Document identifier (e.g., note:xyz or jotdoc:abc) */
  doc_id: string;
  /** Document type (note or jotdoc) */
  doc_type: string;
  /** Number of edits to document */
  edit_count?: number;
  /** Weighted engagement score (views*1 + interactions*5 + edits*10) */
  engagement_score?: number;
  /** Statistics for hover durations */
  hover_duration_stats?: DistributionStats | null;
  /** Number of interactions with document */
  interaction_count?: number;
  /** Total selections in document */
  select_count?: number;
  /** Number of times document was viewed */
  view_count?: number;
};
export type EditAnalytics = {
  /** Average characters changed per edit */
  avg_chars_per_edit?: number | null;
  /** Distribution of character deltas */
  char_delta_distribution?: DistributionStats | null;
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Number of unique sections that were edited */
  sections_edited?: number;
  /** Total number of edits */
  total_edits?: number;
};
export type NoteUsageSummary = {
  /** Avg copy percent over all sections, treating unknown as 0 (0-1) */
  char_weighted_copy_percent_all?: number | null;
  /** Avg copy percent over sections with known copy data (0-1) */
  char_weighted_copy_percent_known?: number | null;
  /** Avg edit percent over all sections, treating unknown as 0 (0-1) */
  char_weighted_edit_percent_all?: number | null;
  /** Avg edit percent over sections with known edit data (0-1) */
  char_weighted_edit_percent_known?: number | null;
  /** Avg selection percent over all sections, treating unknown as 0 (0-1) */
  char_weighted_selection_percent_all?: number | null;
  /** Avg selection percent over sections with known selection data (0-1) */
  char_weighted_selection_percent_known?: number | null;
  /** Percent of sections with text copied (0-1) */
  percent_copied?: number;
  /** Percent of sections edited (0-1) */
  percent_edited?: number;
  /** Percent of sections interacted with (0-1) */
  percent_interacted?: number;
  /** Percent of sections rendered (0-1) */
  percent_rendered?: number;
  /** Number of sections with text copied */
  sections_copied?: number;
  /** Number of sections edited */
  sections_edited?: number;
  /** Number of sections interacted with */
  sections_interacted?: number;
  /** Number of sections rendered */
  sections_rendered?: number;
  /** Total character count of note */
  total_note_chars?: number;
  /** Total number of sections in note */
  total_sections?: number;
};
export type NoteUsageSection = {
  /** Whether section had text copied */
  copied?: boolean;
  /** Max percent of section text copied (0-1) */
  copy_percent_max?: number | null;
  /** Whether section was edited */
  edited?: boolean;
  /** Percent of section edited based on char delta (0-1) */
  edited_percent?: number | null;
  /** Whether section was interacted with */
  interacted?: boolean;
  /** Whether section was rendered */
  rendered?: boolean;
  /** Character count of section text */
  section_chars?: number;
  /** Section identifier */
  section_id: string;
  /** Section title from note */
  section_title?: string | null;
  /** Max percent of section text selected (0-1) */
  selection_percent_max?: number | null;
};
export type SectionAnalytics = {
  /** Statistics for character deltas per edit */
  char_delta_stats?: DistributionStats | null;
  /** Total character delta across all edits */
  char_delta_total?: number;
  /** Total clicks in section */
  click_count?: number;
  /** Total copies from section */
  copy_count?: number;
  /** Number of edits to section */
  edit_count?: number;
  /** Weighted engagement score (views*1 + interactions*5 + edits*10) */
  engagement_score?: number;
  /** Statistics for hover durations */
  hover_duration_stats?: DistributionStats | null;
  /** Number of section_interacted events */
  interaction_count?: number;
  /** Section identifier */
  section_id: string;
  /** Section title (for readability) */
  section_title?: string | null;
  /** Total selections in section */
  select_count?: number;
  /** Number of times section was viewed */
  view_count?: number;
};
export type CopyDetailStats = {
  /** Event IDs of all copy events */
  copy_event_ids?: string[];
  /** Copy rate (copies / selections) for this section */
  copy_rate?: number;
  /** Copy count by modality */
  modality_breakdown?: {
    [key: string]: number;
  };
  /** Distribution of copied character counts */
  selected_chars_stats?: DistributionStats | null;
  /** Distribution of copied percent of total */
  selection_percent_stats?: DistributionStats | null;
  /** Distribution of time from settle to copy (ms) */
  time_to_copy_stats?: DistributionStats | null;
  /** Total copy events */
  total_copies?: number;
};
export type EditDetailStats = {
  /** Distribution of character deltas */
  char_delta_distribution?: DistributionStats | null;
  /** Event IDs of all edit events */
  edit_event_ids?: string[];
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Total character delta across all edits */
  total_char_delta?: number;
  /** Total edits */
  total_edits?: number;
};
export type InteractionDetailStats = {
  /** Distribution of hover durations (ms) */
  hover_duration_stats?: DistributionStats | null;
  /** Event IDs of all interaction events */
  interaction_event_ids?: string[];
  /** Total clicks */
  total_clicks?: number;
  /** Total copies from interactions */
  total_copies?: number;
  /** Total hover duration in milliseconds */
  total_hover_ms?: number;
  /** Total section_interacted events */
  total_interactions?: number;
  /** Total selects */
  total_selects?: number;
};
export type SelectionDetailStats = {
  /** Selection count by modality */
  modality_breakdown?: {
    [key: string]: number;
  };
  /** Distribution of selected character counts */
  selected_chars_stats?: DistributionStats | null;
  /** Event IDs of all selection events */
  selection_event_ids?: string[];
  /** Distribution of selection as percent of total */
  selection_percent_stats?: DistributionStats | null;
  /** Distribution of time to settle (ms) */
  settle_time_stats?: DistributionStats | null;
  /** Total selection events */
  total_selections?: number;
};
export type SectionDetailAnalytics = {
  /** Copy statistics */
  copy: CopyDetailStats;
  /** Base document ID (note:xyz or jotdoc:abc) */
  doc_id: string;
  /** Document type (note or jotdoc) */
  doc_type: string;
  /** Edit statistics */
  edit: EditDetailStats;
  /** Weighted engagement score (edits*20 + copies*10 + hover_seconds*0.1 + renders*1) */
  engagement_score?: number;
  /** ISO timestamp of first event for this section */
  first_seen_at?: string | null;
  /** Interaction statistics */
  interaction: InteractionDetailStats;
  /** ISO timestamp of last event for this section */
  last_seen_at?: string | null;
  /** Number of times section was rendered */
  render_count?: number;
  /** Section identifier */
  section_id: string;
  /** Section title */
  section_title?: string | null;
  /** Selection statistics */
  selection: SelectionDetailStats;
  /** Total touches (rendered + interacted + selected + copied + edited) */
  touch_count?: number;
};
export type SessionSummary = {
  /** Copy rate (copies / selections), or None if no selections */
  copy_rate?: number | null;
  /** ISO timestamp of last event */
  date_range_end?: string | null;
  /** ISO timestamp of first event */
  date_range_start?: string | null;
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Average events per minute */
  event_frequency_per_minute?: number | null;
  /** Event count by event type */
  events_by_type: {
    [key: string]: number;
  };
  /** Duration from first to last event (seconds) */
  session_duration_seconds?: number | null;
  /** Total character delta across all edits (positive = additions, negative = deletions) */
  total_char_delta?: number;
  /** Total number of copy events */
  total_copies?: number;
  /** Total number of edit events */
  total_edits?: number;
  /** Total number of events */
  total_events: number;
  /** Total number of text selection events */
  total_selections?: number;
  /** Number of unique sections that were interacted with */
  unique_sections_interacted?: number;
};
export type TimingAnalytics = {
  /** Edit session durations (ms) */
  edit_duration?: DistributionStats | null;
  /** Section hover durations (ms) */
  hover_duration?: DistributionStats | null;
  /** Time from selection start to settle (ms) */
  selection_settle_time?: DistributionStats | null;
  /** Time from selection settle to copy (ms) */
  time_to_copy?: DistributionStats | null;
};
export type EncounterTelemetryAnalytics = {
  /** Copy/selection analytics */
  copy_analytics: CopyAnalytics;
  /** Analytics per document (note vs jotdocs) */
  document_analytics?: DocumentAnalytics[];
  /** Edit event analytics */
  edit_analytics: EditAnalytics;
  /** Encounter identifier */
  encounter_id: string;
  /** Note identifier (if available) */
  note_id?: string | null;
  /** Main note usage coverage summary */
  note_usage?: NoteUsageSummary | null;
  /** Per-section usage breakdown for main note */
  note_usage_sections?: NoteUsageSection[];
  /** Raw telemetry events */
  raw_events?: {
    [key: string]: any;
  }[];
  /** Analytics per section */
  section_analytics?: SectionAnalytics[];
  /** Detailed analytics per section with comprehensive metrics */
  section_details?: SectionDetailAnalytics[];
  /** Session-level summary */
  session_summary: SessionSummary;
  /** Timing-related distributions */
  timing_analytics: TimingAnalytics;
};
export type AdminTelemetryAnalyticsResponse = {
  /** Comprehensive telemetry analytics */
  analytics: EncounterTelemetryAnalytics;
};
export type SessionSummary2 = {
  /** Copy rate (copies / selections), or None if no selections */
  copy_rate?: number | null;
  /** ISO timestamp of last event */
  date_range_end?: string | null;
  /** ISO timestamp of first event */
  date_range_start?: string | null;
  /** Edit count by source (manual, ai_edit, regeneration) */
  edits_by_source?: {
    [key: string]: number;
  };
  /** Average events per minute */
  event_frequency_per_minute?: number | null;
  /** Event count by event type */
  events_by_type: {
    [key: string]: number;
  };
  /** Duration from first to last event (seconds) */
  session_duration_seconds?: number | null;
  /** Total character delta across all edits (positive = additions, negative = deletions) */
  total_char_delta?: number;
  /** Total number of copy events */
  total_copies?: number;
  /** Total number of edit events */
  total_edits?: number;
  /** Total number of events */
  total_events: number;
  /** Total number of text selection events */
  total_selections?: number;
  /** Number of unique sections that were interacted with */
  unique_sections_interacted?: number;
};
export type AdminTelemetrySessionListItem = {
  /** Session creation timestamp */
  created_at: string;
  /** Encounter identifier */
  encounter_id: string;
  /** Associated note ID if available */
  note_id?: string | null;
  /** Organization ID for the session */
  organization_id?: string | null;
  /** Organization name (enriched) */
  organization_name?: string | null;
  /** Session summary statistics */
  summary: SessionSummary2;
  /** Last update timestamp */
  updated_at: string;
  /** User email (enriched) */
  user_email?: string | null;
  /** User ID (provider) */
  user_id: string;
  /** User name (enriched) */
  user_name?: string | null;
};
export type ListResponseAdminTelemetrySessionListItem = {
  items: AdminTelemetrySessionListItem[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AdminAppointmentSummary = {
  appointment_id: string;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  title?: string | null;
};
export type WorkingBillingClaimLineItemResponse = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type AdminEncounterDetail = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  encounter_id: string;
  encounter_type?: string | null;
  end_time?: string | null;
  input_documents?: number | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  updated_at?: string | null;
  working_billing_claim?: WorkingBillingClaimResponse | null;
};
export type AdminNoteProcessingSessionSummary = {
  created_at?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  status?: string | null;
  transcription_session_ids?: string[] | null;
};
export type AdminNoteSummary = {
  created_at?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  status?: string | null;
  template?: string | null;
};
export type AdminProviderSummary = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminEncounterDetailResponse = {
  appointment?: AdminAppointmentSummary | null;
  encounter: AdminEncounterDetail;
  note_processing_sessions: AdminNoteProcessingSessionSummary[];
  notes: AdminNoteSummary[];
  provider: AdminProviderSummary;
  transcriptions: AdminTranscriptionSummary[];
};
export type WorkingBillingClaimLineItemResponse2 = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse2 = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse2[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type AdminEncounterResponse = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  encounter_id: string;
  encounter_type?: string | null;
  end_time?: string | null;
  input_documents?: number;
  modified_at?: string | null;
  note_id?: string | null;
  note_title?: string | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id: string;
  scheduled_for?: string | null;
  start_time?: string | null;
  status: string;
  template_id?: string | null;
  working_billing_claim?: WorkingBillingClaimResponse2 | null;
};
export type ListResponseAdminEncounterResponse = {
  items: AdminEncounterResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type OrgBillingEncounterResponse = {
  appointment_id?: string | null;
  appointment_info?: {
    [key: string]: any;
  } | null;
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  billable?: boolean;
  /** Canonical encounter identity fields for billing surfaces: DOS, patient, service, provider, and payer. */
  billing_identity?: {
    [key: string]: any;
  } | null;
  canonical_service_type?: {
    [key: string]: any;
  } | null;
  canonical_service_type_slug?: string | null;
  claim_id?: string | null;
  claim_status?: string | null;
  cpt_analysis?: {
    [key: string]: any;
  } | null;
  cpt_codes?: string[];
  created_at?: string | null;
  date_of_service?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  /** Number of CPT codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  has_audit?: boolean;
  has_claim?: boolean;
  icd10_codes?: string[];
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  is_signed?: boolean;
  last_audit_at?: string | null;
  latest_compliance_pct?: number | null;
  latest_quality_score?: number | null;
  modality?: string | null;
  note_id?: string | null;
  note_ids?: string[];
  outputs?: any[];
  patient_id?: string | null;
  patient_info?: {
    [key: string]: any;
  } | null;
  patient_name?: string | null;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  provider_id: string;
  /** Provider billing license state used for fee schedule context */
  provider_license_state?: string | null;
  /** Provider billing license type used for fee schedule context */
  provider_license_type?: string | null;
  provider_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
  scheduled_for?: string | null;
  /** Best-available service date via waterfall: date_of_service → service_rendered_at → appointment.start_time → scheduled_for → created_at. */
  service_date?: string | null;
  service_rendered_at?: string | null;
  status: string;
  summary?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type OrgBillingEncounterListResponse = {
  /** List of billing encounters */
  encounters: OrgBillingEncounterResponse[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of encounters */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type UnifiedEncounterWorklistActions = {
  claim_href?: string | null;
  patient_billing_href?: string | null;
  primary_href: string;
};
export type UnifiedEncounterWorklistAge = {
  anchor?: string | null;
  days?: number | null;
  label: string;
};
export type UnifiedEncounterWorklistClaim = {
  claim_type?: string | null;
  frequency_code?: string | null;
  id?: string | null;
  parent_claim_id?: string | null;
  status?: string | null;
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge_cents?: number | null;
};
export type UnifiedEncounterFlowAction = {
  label: string;
  owner: string;
  severity: "info" | "warning" | "error";
};
export type FlowSourceRef = {
  id: string;
  type: string;
};
export type UnifiedEncounterFlowStage = {
  attention?: "none" | "info" | "warning" | "error";
  attention_reason?: string | null;
  completed_at?: string | null;
  display_label: string;
  key: "schedule" | "support" | "sign" | "submit" | "settle";
  source_refs?: FlowSourceRef[];
  state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  summary?: string | null;
};
export type UnifiedEncounterWorklistFlow = {
  active_stage: "schedule" | "support" | "sign" | "submit" | "settle";
  active_state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  conflicts?: {
    [key: string]: any;
  }[];
  primary_action?: UnifiedEncounterFlowAction | null;
  stages: UnifiedEncounterFlowStage[];
};
export type UnifiedEncounterWorklistIdentity = {
  billing_codes_label?: string;
  coverage_kind?: string | null;
  encounter_id: string;
  is_self_pay?: boolean;
  member_id?: string | null;
  patient_id?: string | null;
  patient_name: string;
  payer_name: string;
  payer_uuid?: string | null;
  provider_id?: string | null;
  provider_license_label?: string | null;
  provider_name: string;
  service_date?: string | null;
  service_label: string;
};
export type UnifiedEncounterWorklistActivity = {
  at?: string | null;
  kind?: string | null;
  label: string;
  relative_label: string;
  source_id?: string | null;
  source_type?: string | null;
};
export type UnifiedEncounterWorklistMoneyCharge = {
  charged_cents?: number;
  expected_cents?: number | null;
  expected_label?: string | null;
};
export type UnifiedEncounterWorklistPatientResponsibility = {
  collected_cents?: number;
  confirmed_cents?: number;
  credit_cents?: number;
  estimated_cents?: number;
  outstanding_cents?: number;
};
export type UnifiedEncounterWorklistMoneyReconciliation = {
  active_invoice_cents?: number;
  active_invoice_ids?: string[];
  collected_cents?: number;
  confirmed_cents?: number;
  confirmed_line_ids?: string[];
  credit_cents?: number;
  estimate_line_ids?: string[];
  estimated_cents?: number;
  explanation?: string | null;
  headline?: string | null;
  payment_entry_ids?: string[];
  recommended_action?: string | null;
  remaining_due_cents?: number;
  stale_invoice_ids?: string[];
  state: string;
};
export type UnifiedEncounterWorklistMoneySecondary = {
  amount_cents?: number;
  kind: string;
  label: string;
};
export type UnifiedEncounterWorklistMoney = {
  amount_cents?: number;
  charge?: UnifiedEncounterWorklistMoneyCharge | null;
  expected_allowed_cents?: number | null;
  expected_allowed_label?: string | null;
  expected_collection_cents?: number | null;
  kind: string;
  label: string;
  patient_responsibility?: UnifiedEncounterWorklistPatientResponsibility | null;
  reconciliation?: UnifiedEncounterWorklistMoneyReconciliation | null;
  secondary?: UnifiedEncounterWorklistMoneySecondary | null;
  undercharge_risk?: boolean;
};
export type UnifiedEncounterWorklistSignal = {
  detail?: string | null;
  label: string;
  owner: "front_desk" | "clinician" | "biller" | "payer" | "patient" | "none";
  severity: "info" | "warning" | "error" | "success";
  stale?: boolean;
  work_state: "all" | "action" | "waiting" | "clear";
};
export type UnifiedEncounterWorklistSupport = {
  eligibility_snapshot_id?: string | null;
  readiness?: string | null;
  readiness_label?: string | null;
  status?: string | null;
};
export type UnifiedEncounterWorklistItem = {
  actions: UnifiedEncounterWorklistActions;
  age: UnifiedEncounterWorklistAge;
  claim: UnifiedEncounterWorklistClaim;
  encounter_id: string;
  flow: UnifiedEncounterWorklistFlow;
  id: string;
  identity: UnifiedEncounterWorklistIdentity;
  last_activity: UnifiedEncounterWorklistActivity;
  money: UnifiedEncounterWorklistMoney;
  provenance?: {
    [key: string]: any;
  };
  signal: UnifiedEncounterWorklistSignal;
  support: UnifiedEncounterWorklistSupport;
};
export type UnifiedEncounterWorklistSegment = {
  count: number;
  key: string;
  label: string;
  severity?: string | null;
};
export type UnifiedEncounterWorklistResponse = {
  items: UnifiedEncounterWorklistItem[];
  page: number;
  per_page: number;
  provenance?: {
    [key: string]: any;
  };
  segments: UnifiedEncounterWorklistSegment[];
  stage_segments: UnifiedEncounterWorklistSegment[];
  summary: string;
  total: number;
  total_pages: number;
};
export type ClaimReferenceResponse = {
  claim_type?: string | null;
  created_at?: string | null;
  id: string;
  insurance_payer_name?: string | null;
  status: string;
  submitted_at?: string | null;
  total_charge_cents?: number;
};
export type NoteAuditSummary = {
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number | null;
  encounter_id?: string | null;
  first_audit_at?: string | null;
  is_completed?: boolean;
  last_audit_at?: string | null;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean | null;
  latest_quality_score?: number | null;
  latest_status?: string | null;
  note_audit_id: string;
  note_id: string;
  note_title?: string | null;
  patient_name?: string | null;
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number | null;
  user_id?: string | null;
  within_quota?: boolean | null;
};
export type AuditRevisionDetail = {
  audit_data?: {
    [key: string]: any;
  } | null;
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean | null;
  cpt_match?: boolean | null;
  created_at?: string | null;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision?: number | null;
  rules_compliant?: number | null;
  rules_non_compliant?: number | null;
  rules_warning?: number | null;
  status?: string | null;
  target_cpt_codes?: string[] | null;
  target_cpt_source?: string | null;
  trigger?: string | null;
};
export type NoteAuditDetail = {
  audit: NoteAuditSummary;
  current_revision?: AuditRevisionDetail | null;
  patient_name?: string | null;
  provider_name?: string | null;
};
export type EncounterBillingSummary = {
  /** Historical invoices linked to this encounter for event timelines. */
  invoices?: {
    [key: string]: any;
  }[];
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Encounter-scoped patient ledger entries for event timelines. */
  ledger_entries?: {
    [key: string]: any;
  }[];
  /** Invoice IDs linked to this encounter's charge lines */
  linked_invoice_ids?: string[];
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Derived estimate-to-confirmed patient responsibility state for this encounter. */
  patient_responsibility_reconciliation?: {
    [key: string]: any;
  } | null;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type OrgBillingEncounterDetailResponse = {
  analyzed_at?: string | null;
  appointment_id?: string | null;
  appointment_info?: {
    [key: string]: any;
  } | null;
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  billable?: boolean;
  /** Canonical encounter identity fields for billing surfaces: DOS, patient, service, provider, and payer. */
  billing_identity?: {
    [key: string]: any;
  } | null;
  canonical_service_type?: {
    [key: string]: any;
  } | null;
  canonical_service_type_slug?: string | null;
  claim_id?: string | null;
  claim_status?: string | null;
  /** All claim references for this encounter */
  claims?: ClaimReferenceResponse[];
  cpt_codes?: string[];
  created_at?: string | null;
  date_of_service?: string | null;
  /** Full encounter analysis data from cortex */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  encounter_id: string;
  encounter_type?: string | null;
  /** Number of CPT codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  has_claim?: boolean;
  icd10_codes?: string[];
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  is_signed?: boolean;
  modality?: string | null;
  /** All note audits for this encounter */
  note_audits?: NoteAuditDetail[];
  note_id?: string | null;
  note_ids?: string[];
  outputs?: any[];
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary | null;
  patient_id?: string | null;
  patient_info?: {
    [key: string]: any;
  } | null;
  patient_name?: string | null;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  provider_id: string;
  /** Provider billing license state used for fee schedule context */
  provider_license_state?: string | null;
  /** Provider billing license type used for fee schedule context */
  provider_license_type?: string | null;
  provider_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
  scheduled_for?: string | null;
  /** Best-available service date via waterfall: date_of_service → service_rendered_at → appointment.start_time → scheduled_for → created_at. */
  service_date?: string | null;
  service_rendered_at?: string | null;
  status: string;
  summary?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type UnifiedEncounterWorkspaceAction = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type UnifiedEncounterClaimAnnotationCounts = {
  errors?: number;
  info?: number;
  total?: number;
  warnings?: number;
};
export type AnnotationSeverity = "error" | "warning" | "info";
export type ClaimAnnotation = {
  /** CMS-1500 box number for the related field (e.g., '33A', '23') */
  cms_box?: string | null;
  /** Primary field that this annotation relates to */
  field?: string | null;
  /** The annotation message */
  message: string;
  /** ID of the rule that generated this annotation (if applicable) */
  rule_id?: string | null;
  /** Human-readable name of the rule (if applicable) */
  rule_name?: string | null;
  /** Severity level of the annotation */
  severity: AnnotationSeverity;
};
export type UnifiedEncounterBillingInputs = {
  billing_code_summary?: string | null;
  date_of_service?: string | null;
  encounter_type?: string | null;
  modality?: string | null;
  provider?: {
    [key: string]: any;
  };
  service?: {
    [key: string]: any;
  };
  signed?: boolean;
};
export type FlowSourceRef2 = {
  id: string;
  type: string;
};
export type UnifiedEncounterClaimLine = {
  adjustment_cents?: number | null;
  adjustment_display?: string | null;
  allowed_cents?: number | null;
  allowed_display?: string | null;
  charge_cents?: number | null;
  charge_display?: string | null;
  claim_line_id?: string | null;
  code: string;
  description?: string | null;
  diagnosis_pointers?: string[];
  expected_allowed_cents?: number | null;
  expected_allowed_display?: string | null;
  expected_collection_cents?: number | null;
  expected_collection_display?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  expected_contractual_adjustment_display?: string | null;
  line_control_number?: string | null;
  modifiers?: string[];
  paid_cents?: number | null;
  paid_display?: string | null;
  patient_responsibility_cents?: number | null;
  patient_responsibility_display?: string | null;
  reason?: string | null;
  source_refs?: FlowSourceRef2[];
  status?: string | null;
  undercharge_risk?: boolean;
  units?: number | null;
  warnings?: string[];
};
export type UnifiedEncounterOverviewClaimSummary = {
  accepted_at?: string | null;
  charge?: string;
  charge_cents?: number;
  claim_id?: string | null;
  claim_type?: string | null;
  clearinghouse_status?: string | null;
  display_id?: string | null;
  expected_allowed?: string | null;
  expected_allowed_cents?: number | null;
  expected_collection?: string | null;
  expected_collection_cents?: number | null;
  expected_contractual_adjustment?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  lines?: UnifiedEncounterClaimLine[];
  patient_control_number?: string | null;
  patient_due?: string;
  patient_due_cents?: number;
  payer?: string | null;
  scrub_status?: string | null;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  /** Machine-readable claim status used for client state decisions. */
  status_code?: string | null;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  submitted_at?: string | null;
  summary?: string | null;
  undercharge_risk?: boolean;
};
export type UnifiedEncounterClaimHistoryClaim = {
  claim_id: string;
  claim_type?: string | null;
  correction_eligible?: boolean;
  created_at?: string | null;
  deletable?: boolean;
  delete_disabled_reason?: string | null;
  display_id?: string | null;
  frequency_code?: string | null;
  new_original_available?: boolean;
  original_reference_number?: string | null;
  parent_claim_id?: string | null;
  patient_control_number?: string | null;
  payer_claim_control_number?: string | null;
  payer_name?: string | null;
  status?: string | null;
  status_label?: string | null;
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge?: string;
  total_charge_cents?: number;
  void_eligible?: boolean;
};
export type UnifiedEncounterClaimHistoryRelationship = {
  from_claim_id: string;
  kind: "correction" | "void" | "new_original_attempt";
  to_claim_id: string;
};
export type UnifiedEncounterClaimHistory = {
  active_claim_id?: string | null;
  claims?: UnifiedEncounterClaimHistoryClaim[];
  relationships?: UnifiedEncounterClaimHistoryRelationship[];
};
export type UnifiedEncounterClaimParticipant = {
  cms_boxes?: string[];
  details?: {
    [key: string]: any;
  };
  id?: string | null;
  primary?: string | null;
  secondary?: string | null;
  source?: string | null;
  status?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterClaimParticipants = {
  billing_entity?: UnifiedEncounterClaimParticipant;
  rendering_provider?: UnifiedEncounterClaimParticipant;
  service_facility?: UnifiedEncounterClaimParticipant;
};
export type UnifiedEncounterArtifact = {
  action?: UnifiedEncounterWorkspaceAction | null;
  available?: boolean;
  description?: string | null;
  key: string;
  label: string;
  source_ref?: FlowSourceRef2 | null;
  status?: string | null;
};
export type UnifiedEncounterCoverageSummary = {
  display_label?: string | null;
  is_self_pay?: boolean;
  kind?: string | null;
  member_id?: string | null;
  payer_name?: string | null;
  plan_name?: string | null;
  support_state?: string | null;
};
export type UnifiedEncounterReadinessItem = {
  detail?: string | null;
  key: string;
  label: string;
  source_refs?: FlowSourceRef2[];
  target_panel?: string | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
};
export type UnifiedEncounterClaimPatient = {
  dob?: string | null;
  id?: string | null;
  identifier?: string | null;
  name?: string | null;
};
export type UnifiedEncounterClaimProblemReason = {
  affected_line_ids?: string[];
  amount_cents?: number | null;
  code?: string | null;
  code_system?: string | null;
  code_system_label?: string | null;
  definition?: string | null;
  description?: string | null;
  display_code?: string | null;
  group_code?: string | null;
  group_code_explanation?: string | null;
  group_code_title?: string | null;
  medium_explanation?: string | null;
  raw_label?: string | null;
  scope?: string;
  short_explanation?: string | null;
  source_label?: string | null;
  source_url?: string | null;
  title?: string | null;
  what_it_means_here?: string | null;
};
export type UnifiedEncounterPostSubmissionClaimLine = {
  adjustment_cents?: number | null;
  adjustment_display?: string | null;
  balance_status?:
    | "balanced"
    | "balanced_with_inference"
    | "unbalanced"
    | "unknown";
  billed_cents?: number | null;
  billed_display?: string | null;
  claim_line_id?: string | null;
  code: string;
  description?: string | null;
  diagnosis_pointers?: string[];
  line_control_number?: string | null;
  modifiers?: string[];
  patient_responsibility_cents?: number | null;
  patient_responsibility_display?: string | null;
  patient_responsibility_source?:
    | ("era_line" | "claim_level_inferred" | "unallocated")
    | null;
  payer_paid_cents?: number | null;
  payer_paid_display?: string | null;
  primary_reason?: UnifiedEncounterClaimProblemReason | null;
  reason_codes?: UnifiedEncounterClaimProblemReason[];
  secondary_pending_cents?: number | null;
  secondary_pending_display?: string | null;
  secondary_pending_source?: ("era_line" | "claim_level_inferred") | null;
  source_refs?: FlowSourceRef2[];
  status?: string;
  units?: number | null;
  unresolved_cents?: number | null;
  unresolved_display?: string | null;
};
export type UnifiedEncounterClaimProblemAffectedLine = {
  adjustment_cents?: number | null;
  billed_cents?: number | null;
  claim_line_id?: string | null;
  cpt?: string | null;
  line_control_number?: string | null;
  modifiers?: string[];
  paid_cents?: number | null;
  patient_responsibility_cents?: number | null;
  reason_codes?: UnifiedEncounterClaimProblemReason[];
};
export type UnifiedEncounterClaimProblemEvidenceLink = {
  id: string;
  label: string;
  type: string;
};
export type UnifiedEncounterClaimProblemFinancials = {
  adjustment_cents?: number | null;
  amount_at_risk_cents?: number | null;
  billed_cents?: number | null;
  patient_responsibility_cents?: number | null;
  payer_paid_cents?: number | null;
};
export type UnifiedEncounterClaimProblemNextAction = {
  confidence_level?: string | null;
  disabled_reason?: string | null;
  label: string;
  owner?: string | null;
  priority?: string | null;
  source?: "deterministic" | "claim_case_review";
};
export type UnifiedEncounterClaimProblemReviewGuidance = {
  action_label?: string | null;
  action_summary?: {
    [key: string]: any;
  } | null;
  confidence_level?: string | null;
  explained_codes?: {
    [key: string]: any;
  }[];
  patient_billing_gate?: {
    [key: string]: any;
  } | null;
  primary_finding?: {
    [key: string]: any;
  } | null;
  problem_explanation?: {
    [key: string]: any;
  } | null;
  recommended_action?: {
    [key: string]: any;
  } | null;
  resolution_path_explanation?: string | null;
  review_id: string;
  root_cause_label?: string | null;
};
export type UnifiedEncounterClaimProblemSummary = {
  affected_lines?: UnifiedEncounterClaimProblemAffectedLine[];
  evidence_links?: UnifiedEncounterClaimProblemEvidenceLink[];
  financials?: UnifiedEncounterClaimProblemFinancials | null;
  headline: string;
  kind:
    | "rejection"
    | "denial"
    | "partial_payment"
    | "reversal"
    | "manual_review"
    | "unknown";
  next_action: UnifiedEncounterClaimProblemNextAction;
  occurred_at?: string | null;
  reason_codes?: UnifiedEncounterClaimProblemReason[];
  reason_of_record?: UnifiedEncounterClaimProblemReason | null;
  review_guidance?: UnifiedEncounterClaimProblemReviewGuidance | null;
  source_kind?: string | null;
  source_label: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  title: string;
};
export type UnifiedEncounterClaimWorkspaceResponse = {
  actions?: UnifiedEncounterWorkspaceAction[];
  annotation_counts?: UnifiedEncounterClaimAnnotationCounts;
  annotations?: ClaimAnnotation[];
  billing_inputs?: UnifiedEncounterBillingInputs;
  claim_header?: UnifiedEncounterOverviewClaimSummary;
  claim_history?: UnifiedEncounterClaimHistory;
  claim_participants?: UnifiedEncounterClaimParticipants;
  cms_artifact?: UnifiedEncounterArtifact | null;
  coverage?: UnifiedEncounterCoverageSummary;
  diagnosis_codes?: string[];
  encounter_id: string;
  issues?: UnifiedEncounterReadinessItem[];
  lifecycle?: {
    [key: string]: any;
  };
  mode?: "empty" | "draft" | "editable" | "submitted" | "read_only";
  patient?: UnifiedEncounterClaimPatient;
  post_submission_lines?: UnifiedEncounterPostSubmissionClaimLine[];
  pricing?: {
    [key: string]: any;
  };
  problem_summary?: UnifiedEncounterClaimProblemSummary | null;
  selected_claim_id?: string | null;
  service_lines?: UnifiedEncounterClaimLine[];
};
export type WorkingClaimLineItem = {
  charge_cents?: number | null;
  code_id: string;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  source: "provider_selected" | "ai_recommended";
  units?: number;
};
export type WorkingBillingClaimPutRequest = {
  /** Optional provenance for each diagnosis code. If omitted, all codes are marked provider_selected. */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  } | null;
  /** ICD-10 diagnosis codes for the claim (max 4 after normalization) */
  diagnosis_codes?: string[];
  /** Optimistic concurrency token. If provided and stale, update returns 409. */
  expected_updated_at?: string | null;
  /** Full replacement list of claim line items */
  line_items?: WorkingClaimLineItem[];
  /** CMS place of service code (e.g. '11', '02') */
  place_of_service?: string | null;
};
export type UnifiedEncounterClaimWorkspaceRefreshRequest = {
  /** Optional full-replace working billing claim payload to persist before rebuilding and scrubbing the claim. */
  working_billing_claim?: WorkingBillingClaimPutRequest | null;
};
export type UnifiedEncounterFlowAction2 = {
  label: string;
  owner: string;
  severity: "info" | "warning" | "error";
};
export type FlowSourceRef3 = {
  id: string;
  type: string;
};
export type UnifiedEncounterFlowStage2 = {
  attention?: "none" | "info" | "warning" | "error";
  attention_reason?: string | null;
  completed_at?: string | null;
  display_label: string;
  key: "schedule" | "support" | "sign" | "submit" | "settle";
  source_refs?: FlowSourceRef3[];
  state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  summary?: string | null;
};
export type UnifiedEncounterBillingFlowResponse = {
  active_stage: "schedule" | "support" | "sign" | "submit" | "settle";
  active_state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  conflicts?: {
    [key: string]: any;
  }[];
  encounter_id: string;
  primary_action?: UnifiedEncounterFlowAction2 | null;
  source_states?: {
    [key: string]: any;
  };
  stages: UnifiedEncounterFlowStage2[];
};
export type UnifiedEncounterBalanceBreakdownItem = {
  key: string;
  label: string;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
  value_cents?: number;
};
export type UnifiedEncounterBalanceSummary = {
  breakdown?: UnifiedEncounterBalanceBreakdownItem[];
  invoice_state?: string;
  last_payment_date?: string | null;
  linked_invoice_ids?: string[];
  paid?: string;
  paid_cents?: number;
  /** Derived patient responsibility reconciliation state comparing eligibility estimates, confirmed ERA responsibility, collected amounts, and active invoice posture. */
  reconciliation?: {
    [key: string]: any;
  } | null;
  remaining?: string;
  remaining_cents?: number;
  responsibility?: string;
  responsibility_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
};
export type FlowSourceRef4 = {
  id: string;
  type: string;
};
export type UnifiedEncounterClaimLine2 = {
  adjustment_cents?: number | null;
  adjustment_display?: string | null;
  allowed_cents?: number | null;
  allowed_display?: string | null;
  charge_cents?: number | null;
  charge_display?: string | null;
  claim_line_id?: string | null;
  code: string;
  description?: string | null;
  diagnosis_pointers?: string[];
  expected_allowed_cents?: number | null;
  expected_allowed_display?: string | null;
  expected_collection_cents?: number | null;
  expected_collection_display?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  expected_contractual_adjustment_display?: string | null;
  line_control_number?: string | null;
  modifiers?: string[];
  paid_cents?: number | null;
  paid_display?: string | null;
  patient_responsibility_cents?: number | null;
  patient_responsibility_display?: string | null;
  reason?: string | null;
  source_refs?: FlowSourceRef4[];
  status?: string | null;
  undercharge_risk?: boolean;
  units?: number | null;
  warnings?: string[];
};
export type UnifiedEncounterOverviewClaimSummary2 = {
  accepted_at?: string | null;
  charge?: string;
  charge_cents?: number;
  claim_id?: string | null;
  claim_type?: string | null;
  clearinghouse_status?: string | null;
  display_id?: string | null;
  expected_allowed?: string | null;
  expected_allowed_cents?: number | null;
  expected_collection?: string | null;
  expected_collection_cents?: number | null;
  expected_contractual_adjustment?: string | null;
  expected_contractual_adjustment_cents?: number | null;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  lines?: UnifiedEncounterClaimLine2[];
  patient_control_number?: string | null;
  patient_due?: string;
  patient_due_cents?: number;
  payer?: string | null;
  scrub_status?: string | null;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  /** Machine-readable claim status used for client state decisions. */
  status_code?: string | null;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  submitted_at?: string | null;
  summary?: string | null;
  undercharge_risk?: boolean;
};
export type UnifiedEncounterWorkspaceAction2 = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type UnifiedEncounterWorkspaceMetric = {
  detail?: string | null;
  label: string;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
};
export type UnifiedEncounterNextActionCard = {
  action?: UnifiedEncounterWorkspaceAction2 | null;
  detail?: string | null;
  evidence_metrics?: UnifiedEncounterWorkspaceMetric[];
};
export type UnifiedEncounterPayerResponseSummary = {
  adjustments?: string;
  adjustments_cents?: number;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  paid?: string;
  paid_cents?: number;
  patient_responsibility?: string;
  patient_responsibility_cents?: number;
  payer?: string | null;
  payer_control_number?: string | null;
  payment_date?: string | null;
  payment_method?: string | null;
  received_at?: string | null;
  record_count?: number;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  summary?: string | null;
  trace?: string | null;
};
export type UnifiedEncounterReadinessItem2 = {
  detail?: string | null;
  key: string;
  label: string;
  source_refs?: FlowSourceRef4[];
  target_panel?: string | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
};
export type UnifiedEncounterTimelineItem = {
  detail?: string | null;
  display_time?: string | null;
  key: string;
  label: string;
  occurred_at?: string | null;
  source_ref?: FlowSourceRef4 | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterOverviewResponse = {
  balance?: UnifiedEncounterBalanceSummary;
  claim?: UnifiedEncounterOverviewClaimSummary2;
  encounter_id: string;
  lifecycle?: {
    [key: string]: any;
  };
  next_action?: UnifiedEncounterNextActionCard;
  payer_response?: UnifiedEncounterPayerResponseSummary;
  pricing?: {
    [key: string]: any;
  };
  readiness?: UnifiedEncounterReadinessItem2[];
  timeline_preview?: UnifiedEncounterTimelineItem[];
};
export type UnifiedEncounterWorkspaceAction3 = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type FlowSourceRef5 = {
  id: string;
  type: string;
};
export type UnifiedEncounterLedgerEntry = {
  amount: string;
  amount_cents?: number;
  key: string;
  label: string;
  source_ref?: FlowSourceRef5 | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterChargePreview = {
  encounter_id: string;
  lines?: UnifiedEncounterLedgerEntry[];
  source?: string;
  status?: string;
  total_due?: string;
  total_due_cents?: number;
};
export type UnifiedEncounterInvoiceSummary = {
  amount: string;
  amount_cents?: number;
  created_at?: string | null;
  delivery_method?: string | null;
  invoice_id: string;
  paid_at?: string | null;
  status: string;
};
export type UnifiedEncounterBalanceBreakdownItem2 = {
  key: string;
  label: string;
  tone?: "default" | "success" | "warning" | "error" | "info";
  value: string;
  value_cents?: number;
};
export type UnifiedEncounterBalanceSummary2 = {
  breakdown?: UnifiedEncounterBalanceBreakdownItem2[];
  invoice_state?: string;
  last_payment_date?: string | null;
  linked_invoice_ids?: string[];
  paid?: string;
  paid_cents?: number;
  /** Derived patient responsibility reconciliation state comparing eligibility estimates, confirmed ERA responsibility, collected amounts, and active invoice posture. */
  reconciliation?: {
    [key: string]: any;
  } | null;
  remaining?: string;
  remaining_cents?: number;
  responsibility?: string;
  responsibility_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterPayerResponseSummary2 = {
  adjustments?: string;
  adjustments_cents?: number;
  forwarded_to_secondary?: boolean;
  line_count?: number;
  paid?: string;
  paid_cents?: number;
  patient_responsibility?: string;
  patient_responsibility_cents?: number;
  payer?: string | null;
  payer_control_number?: string | null;
  payment_date?: string | null;
  payment_method?: string | null;
  received_at?: string | null;
  record_count?: number;
  secondary_pending?: string;
  secondary_pending_cents?: number;
  status?: string;
  status_tone?: "default" | "success" | "warning" | "error" | "info";
  summary?: string | null;
  trace?: string | null;
};
export type UnifiedEncounterPaymentsWorkspaceResponse = {
  actions?: UnifiedEncounterWorkspaceAction3[];
  charge_preview: UnifiedEncounterChargePreview;
  encounter_id: string;
  invoices?: UnifiedEncounterInvoiceSummary[];
  ledger?: UnifiedEncounterLedgerEntry[];
  patient_balance?: UnifiedEncounterBalanceSummary2;
  payer_response?: UnifiedEncounterPayerResponseSummary2;
};
export type EncounterReadinessResponse = {
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  encounter_id: string;
  /** Number of billing codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
};
export type UnifiedEncounterWorkspaceAction4 = {
  disabled?: boolean;
  disabled_reason?: string | null;
  intent:
    | "open_panel"
    | "open_claim"
    | "open_cms"
    | "open_note"
    | "open_remittance"
    | "open_balance"
    | "check_coverage"
    | "sign_note"
    | "create_claim"
    | "create_correction_claim"
    | "void_claim"
    | "create_new_original_claim"
    | "scrub_claim"
    | "submit_claim"
    | "record_payment"
    | "send_invoice";
  label: string;
  severity?: "info" | "warning" | "error";
  target_panel?: string | null;
};
export type FlowSourceRef6 = {
  id: string;
  type: string;
};
export type UnifiedEncounterArtifact2 = {
  action?: UnifiedEncounterWorkspaceAction4 | null;
  available?: boolean;
  description?: string | null;
  key: string;
  label: string;
  source_ref?: FlowSourceRef6 | null;
  status?: string | null;
};
export type UnifiedEncounterClaimHistoryClaim2 = {
  claim_id: string;
  claim_type?: string | null;
  correction_eligible?: boolean;
  created_at?: string | null;
  deletable?: boolean;
  delete_disabled_reason?: string | null;
  display_id?: string | null;
  frequency_code?: string | null;
  new_original_available?: boolean;
  original_reference_number?: string | null;
  parent_claim_id?: string | null;
  patient_control_number?: string | null;
  payer_claim_control_number?: string | null;
  payer_name?: string | null;
  status?: string | null;
  status_label?: string | null;
  submitted_at?: string | null;
  superseded_by_claim_id?: string | null;
  total_charge?: string;
  total_charge_cents?: number;
  void_eligible?: boolean;
};
export type UnifiedEncounterClaimHistoryRelationship2 = {
  from_claim_id: string;
  kind: "correction" | "void" | "new_original_attempt";
  to_claim_id: string;
};
export type UnifiedEncounterClaimHistory2 = {
  active_claim_id?: string | null;
  claims?: UnifiedEncounterClaimHistoryClaim2[];
  relationships?: UnifiedEncounterClaimHistoryRelationship2[];
};
export type UnifiedEncounterFlowAction3 = {
  label: string;
  owner: string;
  severity: "info" | "warning" | "error";
};
export type UnifiedEncounterFlowStage3 = {
  attention?: "none" | "info" | "warning" | "error";
  attention_reason?: string | null;
  completed_at?: string | null;
  display_label: string;
  key: "schedule" | "support" | "sign" | "submit" | "settle";
  source_refs?: FlowSourceRef6[];
  state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  summary?: string | null;
};
export type UnifiedEncounterBillingFlowResponse2 = {
  active_stage: "schedule" | "support" | "sign" | "submit" | "settle";
  active_state:
    | "not_started"
    | "open"
    | "waiting"
    | "action_needed"
    | "blocked"
    | "complete"
    | "terminal";
  conflicts?: {
    [key: string]: any;
  }[];
  encounter_id: string;
  primary_action?: UnifiedEncounterFlowAction3 | null;
  source_states?: {
    [key: string]: any;
  };
  stages: UnifiedEncounterFlowStage3[];
};
export type UnifiedEncounterIdentityItem = {
  entity_id?: string | null;
  key: "dos" | "patient" | "service" | "provider" | "payer";
  label: string;
  link_intent?:
    | ("encounter" | "patient" | "provider" | "payer" | "service")
    | null;
  primary: string;
  secondary?: string | null;
};
export type UnifiedEncounterHeaderIdentity = {
  items: UnifiedEncounterIdentityItem[];
};
export type UnifiedEncounterHeaderAction = {
  intent?:
    | (
        | "open_panel"
        | "open_claim"
        | "open_cms"
        | "open_note"
        | "open_remittance"
        | "open_balance"
        | "check_coverage"
        | "sign_note"
        | "create_claim"
        | "create_correction_claim"
        | "void_claim"
        | "create_new_original_claim"
        | "scrub_claim"
        | "submit_claim"
        | "record_payment"
        | "send_invoice"
      )
    | null;
  label: string;
  owner?: string | null;
  severity?: "info" | "warning" | "error";
  target_stage?: ("schedule" | "support" | "sign" | "submit" | "settle") | null;
};
export type UnifiedEncounterHeaderChip = {
  color?: "default" | "primary" | "success" | "warning" | "error" | "info";
  label: string;
  variant?: "filled" | "outlined" | "soft";
};
export type UnifiedEncounterHeader = {
  flow: UnifiedEncounterBillingFlowResponse2;
  identity: UnifiedEncounterHeaderIdentity;
  primary_action?: UnifiedEncounterHeaderAction | null;
  status_chips?: UnifiedEncounterHeaderChip[];
  title: string;
};
export type UnifiedEncounterTimelineItem2 = {
  detail?: string | null;
  display_time?: string | null;
  key: string;
  label: string;
  occurred_at?: string | null;
  source_ref?: FlowSourceRef6 | null;
  tone?: "default" | "success" | "warning" | "error" | "info";
};
export type UnifiedEncounterBillingResponse = {
  artifacts?: UnifiedEncounterArtifact2[];
  claim_history?: UnifiedEncounterClaimHistory2;
  debug?: {
    [key: string]: any;
  };
  encounter_id: string;
  header: UnifiedEncounterHeader;
  linked_refs?: FlowSourceRef6[];
  timeline?: UnifiedEncounterTimelineItem2[];
};
export type AppointmentResponseBase = {
  /** Appointment ID */
  appointment_id: string;
  /** Optional cancellation reason */
  cancellation_reason?: string | null;
  /** Source surface or workflow for the cancellation */
  cancellation_source?: string | null;
  /** Timestamp when appointment was intentionally cancelled */
  cancelled_at?: string | null;
  /** Actor type that cancelled the appointment */
  cancelled_by_actor_type?: string | null;
  /** User ID of the actor who cancelled the appointment */
  cancelled_by_user_id?: string | null;
  /** Timestamp when patient was checked in */
  checked_in_at?: string | null;
  /** Timestamp when visit was checked out */
  checked_out_at?: string | null;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Optional reason for the confirmation-status change */
  confirmation_status_change_reason?: string | null;
  /** Source surface or workflow for the confirmation-status change */
  confirmation_status_change_source?: string | null;
  /** Timestamp of the last confirmation-status transition */
  confirmation_status_changed_at?: string | null;
  /** Actor type that changed the confirmation status */
  confirmation_status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the confirmation status */
  confirmation_status_changed_by_user_id?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Timestamp when appointment was deleted from the schedule */
  deleted_at?: string | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Optional reason for the slot-status change */
  status_change_reason?: string | null;
  /** Source surface or workflow for the slot-status change */
  status_change_source?: string | null;
  /** Timestamp of the last slot-status transition */
  status_changed_at?: string | null;
  /** Actor type that changed the slot status */
  status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the slot status */
  status_changed_by_user_id?: string | null;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
  /** Visit lifecycle status (not_started, checked_in, in_progress, checked_out, no_show) */
  visit_status?: string;
  /** Optional reason for the visit-status change */
  visit_status_change_reason?: string | null;
  /** Source surface or workflow for the visit-status change */
  visit_status_change_source?: string | null;
  /** Timestamp of the last visit-status transition */
  visit_status_changed_at?: string | null;
  /** Actor type that changed the visit status */
  visit_status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the visit status */
  visit_status_changed_by_user_id?: string | null;
};
export type ClaimReference = {
  /** Claim type (original, corrected, void) */
  claim_type?: string | null;
  /** When the claim was created */
  created_at?: string | null;
  /** Claim UUID */
  id: string;
  /** Insurance payer name for display */
  insurance_payer_name?: string | null;
  /** Claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected) */
  status: string;
  /** When the claim was submitted */
  submitted_at?: string | null;
  /** Total charges in cents */
  total_charge_cents?: number;
};
export type ComputedDefaults = {
  /** Default values for attestation checkboxes */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Default CPT codes from encounter type */
  cpt_codes?: string[];
  /** Default ICD-10 codes from last patient encounter */
  icd10_codes?: string[];
  /** Default modality */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Default place of service code */
  place_of_service?: string | null;
};
export type DocumentCountsMap = {
  /** Map of document type to count */
  counts: {
    [key: string]: number;
  };
  /** Total count of all documents */
  total: number;
};
export type DocumentSummary = {
  /** Count of input documents by type */
  input_counts: DocumentCountsMap;
  /** Count of output documents by type */
  output_counts: DocumentCountsMap;
};
export type EncounterDocumentReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Encounter document ID */
  encounter_document_id: string;
  /** Output status */
  status?: "pending" | "completed";
  /** Document title for display */
  title?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** JotDoc ID (None for pending outputs) */
  jotdoc_id?: string | null;
  /** Output status */
  status?: "pending" | "completed";
  /** Task ID for tracking (optional, for debugging) */
  task_id?: string | null;
  /** Thread ID for building SSE stream URL */
  thread_id?: string | null;
  /** Document title */
  title?: string | null;
  /** Document type */
  type?: string;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type EncounterBillingSummary2 = {
  /** Historical invoices linked to this encounter for event timelines. */
  invoices?: {
    [key: string]: any;
  }[];
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Encounter-scoped patient ledger entries for event timelines. */
  ledger_entries?: {
    [key: string]: any;
  }[];
  /** Invoice IDs linked to this encounter's charge lines */
  linked_invoice_ids?: string[];
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Derived estimate-to-confirmed patient responsibility state for this encounter. */
  patient_responsibility_reconciliation?: {
    [key: string]: any;
  } | null;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type WorkingBillingClaimLineItemResponse3 = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse3 = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse3[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type EncounterResponse = {
  /** Associated appointment if any */
  appointment?: AppointmentResponseBase | null;
  /** Flexible attestation data */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Whether the current user can delete transcripts (owner or org admin) */
  can_delete_transcripts?: boolean | null;
  /** Associated claims for this encounter (all versions: original, corrected, void) */
  claims?: ClaimReference[] | null;
  /** Suggested default values based on patient, encounter_type, and modality. Frontend can apply these when appropriate. */
  computed_defaults?: ComputedDefaults | null;
  /** CPT codes selected for this encounter */
  cpt_codes?: string[];
  /** Creation timestamp */
  created_at: string;
  /** Canonical billing date (CMS-1500 Box 24A) */
  date_of_service?: string | null;
  /** Summary of document counts */
  document_summary?: DocumentSummary | null;
  /** Encounter analysis payload if available */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  /** Encounter ID */
  encounter_id: string;
  /** Encounter type */
  encounter_type?: string | null;
  /** Encounter type ID (from the linked appointment, if any) */
  encounter_type_id?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** ICD-10 diagnosis codes for billing (max 4, first is primary) */
  icd10_codes?: string[];
  /** Input documents or recordings */
  inputs?: EncounterDocumentReference[];
  /** How the encounter was conducted */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Last modification timestamp */
  modified_at?: string | null;
  /** Legacy note ID */
  note_id?: string | null;
  /** Note title */
  note_title?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Output documents or notes */
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  /** Associated patient information */
  patient?: PatientInfo | null;
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary2 | null;
  /** Patient ID */
  patient_id?: string | null;
  /** CMS place of service code (e.g., '11', '10', '02') */
  place_of_service?: string | null;
  /** Provider ID */
  provider_id: string;
  /** When the encounter was scheduled for. Canonical sort key for encounter lists; UI should display this so the visible date matches the order. */
  scheduled_for?: string | null;
  /** Timestamp confirming service was rendered */
  service_rendered_at?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Encounter status */
  status: string;
  /** Template ID */
  template_id?: string | null;
  /** Whether transcripts have been deleted for this encounter */
  transcripts_deleted?: boolean;
  /** Last update timestamp */
  updated_at: string;
  /** Canonical encounter-level working billing claim (read-only) */
  working_billing_claim?: WorkingBillingClaimResponse3 | null;
};
export type EncounterListResponse = {
  /** List of encounters */
  items: EncounterResponse[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of encounters */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type AppointmentResponseBase2 = {
  /** Appointment ID */
  appointment_id: string;
  /** Optional cancellation reason */
  cancellation_reason?: string | null;
  /** Source surface or workflow for the cancellation */
  cancellation_source?: string | null;
  /** Timestamp when appointment was intentionally cancelled */
  cancelled_at?: string | null;
  /** Actor type that cancelled the appointment */
  cancelled_by_actor_type?: string | null;
  /** User ID of the actor who cancelled the appointment */
  cancelled_by_user_id?: string | null;
  /** Timestamp when patient was checked in */
  checked_in_at?: string | null;
  /** Timestamp when visit was checked out */
  checked_out_at?: string | null;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Optional reason for the confirmation-status change */
  confirmation_status_change_reason?: string | null;
  /** Source surface or workflow for the confirmation-status change */
  confirmation_status_change_source?: string | null;
  /** Timestamp of the last confirmation-status transition */
  confirmation_status_changed_at?: string | null;
  /** Actor type that changed the confirmation status */
  confirmation_status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the confirmation status */
  confirmation_status_changed_by_user_id?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Timestamp when appointment was deleted from the schedule */
  deleted_at?: string | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Optional reason for the slot-status change */
  status_change_reason?: string | null;
  /** Source surface or workflow for the slot-status change */
  status_change_source?: string | null;
  /** Timestamp of the last slot-status transition */
  status_changed_at?: string | null;
  /** Actor type that changed the slot status */
  status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the slot status */
  status_changed_by_user_id?: string | null;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
  /** Visit lifecycle status (not_started, checked_in, in_progress, checked_out, no_show) */
  visit_status?: string;
  /** Optional reason for the visit-status change */
  visit_status_change_reason?: string | null;
  /** Source surface or workflow for the visit-status change */
  visit_status_change_source?: string | null;
  /** Timestamp of the last visit-status transition */
  visit_status_changed_at?: string | null;
  /** Actor type that changed the visit status */
  visit_status_changed_by_actor_type?: string | null;
  /** User ID of the actor that changed the visit status */
  visit_status_changed_by_user_id?: string | null;
};
export type ClaimReference2 = {
  /** Claim type (original, corrected, void) */
  claim_type?: string | null;
  /** When the claim was created */
  created_at?: string | null;
  /** Claim UUID */
  id: string;
  /** Insurance payer name for display */
  insurance_payer_name?: string | null;
  /** Claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected) */
  status: string;
  /** When the claim was submitted */
  submitted_at?: string | null;
  /** Total charges in cents */
  total_charge_cents?: number;
};
export type ComputedDefaults2 = {
  /** Default values for attestation checkboxes */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Default CPT codes from encounter type */
  cpt_codes?: string[];
  /** Default ICD-10 codes from last patient encounter */
  icd10_codes?: string[];
  /** Default modality */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Default place of service code */
  place_of_service?: string | null;
};
export type DocumentCountsMap2 = {
  /** Map of document type to count */
  counts: {
    [key: string]: number;
  };
  /** Total count of all documents */
  total: number;
};
export type DocumentSummary2 = {
  /** Count of input documents by type */
  input_counts: DocumentCountsMap2;
  /** Count of output documents by type */
  output_counts: DocumentCountsMap2;
};
export type EncounterDocumentReference2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Encounter document ID */
  encounter_document_id: string;
  /** Output status */
  status?: "pending" | "completed";
  /** Document title for display */
  title?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** JotDoc ID (None for pending outputs) */
  jotdoc_id?: string | null;
  /** Output status */
  status?: "pending" | "completed";
  /** Task ID for tracking (optional, for debugging) */
  task_id?: string | null;
  /** Thread ID for building SSE stream URL */
  thread_id?: string | null;
  /** Document title */
  title?: string | null;
  /** Document type */
  type?: string;
};
export type InsuranceSummary2 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary2[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type EncounterBillingSummary3 = {
  /** Historical invoices linked to this encounter for event timelines. */
  invoices?: {
    [key: string]: any;
  }[];
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Encounter-scoped patient ledger entries for event timelines. */
  ledger_entries?: {
    [key: string]: any;
  }[];
  /** Invoice IDs linked to this encounter's charge lines */
  linked_invoice_ids?: string[];
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Derived estimate-to-confirmed patient responsibility state for this encounter. */
  patient_responsibility_reconciliation?: {
    [key: string]: any;
  } | null;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type WorkingBillingClaimLineItemResponse4 = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse4 = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse4[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type EncounterResponse2 = {
  /** Associated appointment if any */
  appointment?: AppointmentResponseBase2 | null;
  /** Flexible attestation data */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Whether the current user can delete transcripts (owner or org admin) */
  can_delete_transcripts?: boolean | null;
  /** Associated claims for this encounter (all versions: original, corrected, void) */
  claims?: ClaimReference2[] | null;
  /** Suggested default values based on patient, encounter_type, and modality. Frontend can apply these when appropriate. */
  computed_defaults?: ComputedDefaults2 | null;
  /** CPT codes selected for this encounter */
  cpt_codes?: string[];
  /** Creation timestamp */
  created_at: string;
  /** Canonical billing date (CMS-1500 Box 24A) */
  date_of_service?: string | null;
  /** Summary of document counts */
  document_summary?: DocumentSummary2 | null;
  /** Encounter analysis payload if available */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  /** Encounter ID */
  encounter_id: string;
  /** Encounter type */
  encounter_type?: string | null;
  /** Encounter type ID (from the linked appointment, if any) */
  encounter_type_id?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** ICD-10 diagnosis codes for billing (max 4, first is primary) */
  icd10_codes?: string[];
  /** Input documents or recordings */
  inputs?: EncounterDocumentReference2[];
  /** How the encounter was conducted */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Last modification timestamp */
  modified_at?: string | null;
  /** Legacy note ID */
  note_id?: string | null;
  /** Note title */
  note_title?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Output documents or notes */
  outputs?: (EncounterDocumentReference2 | JotDocReference2)[];
  /** Associated patient information */
  patient?: PatientInfo2 | null;
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary3 | null;
  /** Patient ID */
  patient_id?: string | null;
  /** CMS place of service code (e.g., '11', '10', '02') */
  place_of_service?: string | null;
  /** Provider ID */
  provider_id: string;
  /** When the encounter was scheduled for. Canonical sort key for encounter lists; UI should display this so the visible date matches the order. */
  scheduled_for?: string | null;
  /** Timestamp confirming service was rendered */
  service_rendered_at?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Encounter status */
  status: string;
  /** Template ID */
  template_id?: string | null;
  /** Whether transcripts have been deleted for this encounter */
  transcripts_deleted?: boolean;
  /** Last update timestamp */
  updated_at: string;
  /** Canonical encounter-level working billing claim (read-only) */
  working_billing_claim?: WorkingBillingClaimResponse4 | null;
};
export type AppointmentCreateFromEncounter = {
  /** Appointment duration in minutes (required) */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Patient ID for the appointment (optional) */
  patient_id?: string | null;
  /** Appointment start time (required) */
  start_time: string;
  /** Template ID */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
};
export type CreateEncounterRequest = {
  /** Whether to compute and apply attestation defaults (modality, place_of_service, icd10_codes, attestations) based on organization, encounter type, and patient context */
  apply_defaults?: boolean | null;
  /** Data to create a new appointment along with the encounter */
  appointment?: AppointmentCreateFromEncounter | null;
  /** Whether to create a default 'Additional Notes' document */
  default_note?: boolean | null;
  /** Encounter type */
  encounter_type?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** Input documents for the encounter */
  inputs?: {
    [key: string]: any;
  }[];
  /** Note title */
  note_title?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Template ID */
  template_id?: string | null;
};
export type CreateTranscriptOnEncounterFromExampleRequest = {
  encounter_id: string;
  example_transcript: string;
};
export type AttestationValuesResponse = {
  /** Default values for attestation checkboxes */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Default CPT codes */
  cpt_codes?: string[];
  /** Default ICD-10 codes */
  icd10_codes?: string[];
  /** Default modality */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Default place of service code */
  place_of_service?: string | null;
};
export type AttestationDefaultsApiResponse = {
  /** Computed default values including attestation checkbox defaults */
  defaults: AttestationValuesResponse;
  /** Source of each default value */
  sources: {
    [key: string]: string;
  };
};
export type LogTelemetryEventsResponse = {
  /** Encounter ID that was updated */
  encounter_id: string;
  /** Number of events logged in this batch */
  events_logged: number;
  /** Success message */
  message?: string;
};
export type LogTelemetryEventsRequest = {
  /** Encounter identifier */
  encounter_id: string;
  /** List of telemetry events (1-100 per batch) */
  events: {
    [key: string]: any;
  }[];
  /** Optional associated note ID */
  note_id?: string | null;
};
export type TelemetrySessionResponse = {
  /** ISO timestamp of session creation */
  created_at: string;
  /** Encounter identifier */
  encounter_id: string;
  /** Associated note ID */
  note_id?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** ISO timestamp of last update */
  updated_at: string;
  /** Provider/user ID */
  user_id: string;
};
export type FormRuleSchema = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type AppointmentStatus =
  | "scheduled"
  | "cancelled"
  | "rescheduled"
  | "suggested"
  | "rejected";
export type AppointmentUpdate = {
  /** Create a new series from this appointment */
  create_series?: boolean | null;
  /** Detach this appointment from its series and set the series to end before this occurrence */
  detach_from_series?: boolean | null;
  /** New appointment duration in minutes */
  duration?: number | null;
  /** New encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID (alternative to encounter_type/template_id) */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?: FormRuleSchema[] | null;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Lock the rules to prevent them from being overridden by defaults */
  override_defaults?: boolean | null;
  /** Patient ID for the appointment */
  patient_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?: ReminderRuleSchema[] | null;
  /** RFC 5545 recurrence rule for creating a series */
  rrule?: string | null;
  /** End date for the new series */
  series_end_date?: string | null;
  /** New appointment start time */
  start_time?: string | null;
  /** New appointment status */
  status?: AppointmentStatus | null;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** New template ID */
  template_id?: string | null;
};
export type AppointmentCreateFromEncounter2 = {
  /** Appointment duration in minutes (required) */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Patient ID for the appointment (optional) */
  patient_id?: string | null;
  /** Appointment start time (required) */
  start_time: string;
  /** Template ID */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
};
export type EncounterUpdate = {
  /** Updates to make to the associated appointment, or data to create a new one if none exists */
  appointment?: AppointmentUpdate | AppointmentCreateFromEncounter2 | null;
  /** Flexible attestation data (telehealth_consent, pdmp_reviewed, etc.) */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Whether to create a new appointment if one doesn't exist. If true, required fields must be provided. */
  create_appointment?: boolean | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID. Preferred over encounter_type — avoids name-based matching. */
  encounter_type_id?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** How the encounter was conducted */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Note title */
  note_title?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Encounter status */
  status?: ("pending" | "processing" | "completed") | null;
  /** Template ID */
  template_id?: string | null;
};
export type InsuranceSummary3 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo3 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary3[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type ActionResponse = {
  action_id: string;
  action_payload: {
    [key: string]: any;
  };
  action_type: string;
  created_at: string;
  encounter_id: string | null;
  patient?: PatientInfo3 | null;
  provider_id: string;
  state: string;
  updated_at: string;
};
export type ActionListResponse = {
  items: ActionResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type DocumentResponse = {
  /** Document content */
  content?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Document description */
  description?: string | null;
  /** Document ID */
  encounter_document_id: string;
  /** Last modification timestamp */
  modified_at: string;
  /** Document title */
  title?: string | null;
  /** Transcription session ID for recording documents */
  transcription_session_id?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type CreateDocumentRequest = {
  /** Document content */
  content?: string | null;
  /** Document description */
  description?: string | null;
  /** Document title */
  title?: string | null;
  /** Transcription session ID for recording documents */
  transcription_session_id?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type DocumentUpdate = {
  /** Document content */
  content?: string | null;
  /** Document description */
  description?: string | null;
  /** Document title */
  title?: string | null;
};
export type WorkflowStepInfo = {
  /** Human-readable step name */
  display_name: string;
  /** Step identifier */
  id: string;
  /** Step order (0-indexed) */
  order: number;
};
export type EncounterProcessingStatusResponse = {
  /** List of completed step IDs */
  completed_steps?: string[];
  /** ID of the currently executing step */
  current_step?: string | null;
  /** Human-readable name of current step */
  current_step_display_name?: string | null;
  /** Encounter ID */
  encounter_id: string;
  /** Associated note ID */
  note_id?: string | null;
  /** Current status: pending, processing, completed, error */
  status: string;
  /** Full list of workflow steps (visible only) with metadata */
  steps?: WorkflowStepInfo[];
  /** Thread ID for the workflow */
  thread_id: string;
  /** Total number of visible steps */
  total_steps?: number;
  /** Name of the workflow being executed */
  workflow_name?: string | null;
};
export type TranscriptDeletionResponse = {
  /** Number of analysis sessions hard-deleted */
  analysis_sessions_deleted?: number;
  /** ID of the encounter */
  encounter_id: string;
  /** Number of notes with transcripts cleared */
  notes_cleared?: number;
  /** Number of transcription sessions soft-deleted */
  transcription_sessions_deleted?: number;
};
export type WorkingClaimLineItem2 = {
  charge_cents?: number | null;
  code_id: string;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  source: "provider_selected" | "ai_recommended";
  units?: number;
};
export type WorkingBillingClaimPutRequest2 = {
  /** Optional provenance for each diagnosis code. If omitted, all codes are marked provider_selected. */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  } | null;
  /** ICD-10 diagnosis codes for the claim (max 4 after normalization) */
  diagnosis_codes?: string[];
  /** Optimistic concurrency token. If provided and stale, update returns 409. */
  expected_updated_at?: string | null;
  /** Full replacement list of claim line items */
  line_items?: WorkingClaimLineItem2[];
  /** CMS place of service code (e.g. '11', '02') */
  place_of_service?: string | null;
};
